import styled from "styled-components";

export const HomeBg = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
`;
